import { render } from "./InvitedOffPlatform.vue.js?vue&type=template&id=b90ab866&scoped=true!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./InvitedOffPlatform.vue?vue&type=template&id=b90ab866&scoped=true"
import script from "./InvitedOffPlatform.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./InvitedOffPlatform.vue?vue&type=script&lang=js"
export * from "./InvitedOffPlatform.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./InvitedOffPlatform.vue?vue&type=script&lang=js"

import "./InvitedOffPlatform.vue.css?vue&type=style&index=0&id=b90ab866&scoped=true&lang=css!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./InvitedOffPlatform.vue?vue&type=style&index=0&id=b90ab866&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b90ab866"],['__file',"src/Web/scripts/pages/InvitedOffPlatform.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b90ab866"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b90ab866', __exports__)) {
    api.reload('b90ab866', __exports__)
  }
  
  module.hot.accept("./InvitedOffPlatform.vue.js?vue&type=template&id=b90ab866&scoped=true!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./InvitedOffPlatform.vue?vue&type=template&id=b90ab866&scoped=true", () => {
    api.rerender('b90ab866', render)
  })

}


export default __exports__